import React from 'react';
import {
  CommonDropdownOutlined,
  ValidCashPayoutIdList,
  ModalFactory,
  CashPickupLocation
} from '@Components';
import { Field, change } from 'redux-form';
import { required } from '../../utils/validation';
import { connect } from 'react-redux';
import {
  PAYOUT_TITLE,
  SELF_POPULATING_FIELDS,
  beneficiaryFieldsForINvalidation,
  cashPickupNote
} from './constant';
import compact from 'lodash/compact';
import {
  getPayeeJSONSchemaByCountryCode,
  getPayeeJSONSchemaByRoutingConfigId
} from '@Redux/actions/payee-data';
import PayoutScreen from './payout-info/index';
import get from 'lodash/get';
import filter from 'lodash/filter';
import {
  PayoutMethod,
  RenderRecevingOptions,
  Container,
  RenderTitle,
  SubTitle,
  NewIcon,
  SectionTitle,
  RenderRecipientNote
} from './styled-components';
import Grid from 'semantic-ui-react/dist/commonjs/collections/Grid';
import { dispatchConstFields, refactorConditionalField, resetAllFields } from './common';
import cloneDeep from 'lodash/cloneDeep';
import isEmpty from 'lodash/isEmpty';
import merge from 'lodash/merge';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import { INDIVIDUAL, PH } from '../../utils/constants';
import { LabelTextWrapper } from './styles';
import { getCashPayoutLocationList } from '@Redux/actions/individual-user-flow';
import _ from 'lodash';
import { NEW_ICON } from '@Images';
import { storeSchemBeneValiation } from '@Redux/actions/transaction/transaction-action';
import { activateLoader, disableLoader } from '@Redux/actions/ui-trigger';

//Used for BeneDetailsContainer for Bene schema enabled countries

class BeneDetailsContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.EDIT_CASE_MANUAL_HANDLING_FIELDS = [
      {
        field: 'beneficiary_country_code',
        handler: this.onCountryOfResidenceChangeHandler,
        group: 'personal_details',
        value_key: 'details_selected'
      }
    ];
    this.state = {
      beneSchema: {},
      beneSchemaOriginal: {},
      conditionalValidation: {},
      selectedPayoutMethod: {},
      addressSchema: {},
      showAddressSearch: false,
      searchBarProps: null,
      showFields: false,
      lastRecordedNameValue: '',
      beneCountryFieldDisabled: false
    };
  }

  setBeneCountryFieldDisabled = (value) => {
    this.setState({ beneCountryFieldDisabled: value });
  };

  formatBeneConfigToRender = (beneConfig) => {
    return compact(
      beneConfig.map((item, index) => {
        return {
          text: item.label,
          value: item.payout_method,
          key: index,
          subtitle: item.note,
          routing_config_type: item.routing_config_type
        };
      })
    );
  };

  UNSAFE_componentWillMount = () => {
    const { isVopTransactionFlow, isNewBeneAddFlow, dispatch } = this.props;
    !(isVopTransactionFlow || isNewBeneAddFlow) &&
      dispatch(change(this.props.formName, 'details_selected', ''));
  };

  componentDidMount = async () => {
    const {
      beneConfig,
      formValues: { payout_method, details_selected },
      currentBeneDetails,
      dispatch,
      formName,
      isCompleteEditable,
      isPartiallyEditable,
      isVopTransactionFlow,
      isNewBeneAddFlow
    } = this.props;
    const isEditCase = isCompleteEditable || isPartiallyEditable;
    if (details_selected && beneConfig && (isVopTransactionFlow || isNewBeneAddFlow)) {
      // Auto selecting Payout method in VOP flow and field will not render
      const beneFormat = this.formatBeneConfigToRender(beneConfig);
      const selectedConfig = beneFormat.find((config) => config.value === details_selected);
      if (selectedConfig) {
        await this.payoutMethodSelected(details_selected, beneFormat);
      }
    } else if (beneConfig && isEditCase ? beneConfig.length > 0 : beneConfig.length === 1) {
      const beneFormat = this.formatBeneConfigToRender(beneConfig);
      await this.payoutMethodSelected(beneFormat[0].value, beneFormat);
    }
    if (!isEmpty(currentBeneDetails) && payout_method) {
      await this.payoutMethodSelected(payout_method, currentBeneDetails.routing_config_type);
      await this.manualHandlerInvoke(this.props.currentBeneDetails);
      await this.props.initializeFormForBeneService?.();
      //to make the value match the value present in options array
      //so that value will be visible in the field
      let beneficiary_bank_name = null;
      switch (currentBeneDetails.routing_code_type_1) {
        case 'SWIFT':
          beneficiary_bank_name =
            currentBeneDetails.beneficiary_bank_name +
            '(->' +
            currentBeneDetails.routing_code_value_1 +
            '<-)';

          break;
        case 'BRANCH_CODE':
          beneficiary_bank_name =
            currentBeneDetails.beneficiary_bank_name +
            '(->' +
            currentBeneDetails.beneficiary_bank_code +
            '<-)';
          break;
        default:
          break;
      }
      beneficiary_bank_name &&
        dispatch(change(formName, 'beneficiary_bank_name', beneficiary_bank_name));
    }
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { formValues, dispatch, formName } = this.props;
    const { payout_details } = this.state.beneSchema;
    if (!isEmpty(formValues) && !isEmpty(nextProps.formValues) && !isEmpty(payout_details)) {
      Object.keys(payout_details).forEach((field) => {
        Object.keys(formValues).forEach((key) => {
          if (
            payout_details[field].render['value_field_name'] === key &&
            !isEmpty(payout_details[field].render.api_validation)
          ) {
            formValues[key] !== nextProps.formValues[key] &&
              dispatch(change(formName, key + '_success', false));
          }
        });
      });
    }
  }

  reInitializeForm = async () => {
    // for address section
    const {
      formValues: { payout_method },
      currentBeneDetails
    } = this.props;
    if (!isEmpty(currentBeneDetails) && payout_method) {
      await this.props.initializeFormForBeneService?.();
    }
  };

  renderPaypoutMethods = (payoutMethods) => {
    if (!payoutMethods) payoutMethods = [];
    return payoutMethods.map((method) => {
      const { text, key, value, subtitle } = method;
      return {
        key,
        value,
        text: text,
        content: (
          <PayoutMethod>
            <RenderTitle id={`title-${value}`}>
              {text}
              {(value === 'cash' ||
                value === 'money_cash' ||
                ['WALLET', 'CASH'].includes(value)) && <NewIcon src={NEW_ICON}></NewIcon>}
            </RenderTitle>
            <SubTitle id={`sub-title-${value}`}>{subtitle}</SubTitle>
          </PayoutMethod>
        )
      };
    });
  };

  payoutMethodSelected = async (value, staticValues) => {
    await this.setState({
      selectedPayoutMethod: value
    });
    const {
      isCompleteEditable,
      isPartiallyEditable,
      dispatch,
      formName,
      onCountryCurrencyPairChange,
      isVopTransactionFlow,
      isNewBeneAddFlow
    } = this.props;
    const isEditCase =
      isVopTransactionFlow || isNewBeneAddFlow || isCompleteEditable || isPartiallyEditable;
    if (value) {
      if (!isEditCase) {
        resetAllFields({
          dispatch,
          change,
          formName
        });
      }
      let routing_config_type;
      if (typeof staticValues === 'string') {
        routing_config_type = staticValues;
      } else {
        routing_config_type = staticValues?.find((obj) => obj.value === value)?.routing_config_type;
      }
      dispatch(activateLoader());
      dispatch(change(formName, 'details_selected', value));
      const response = await this.props.getPayeeJSONSchemaByRoutingConfigId(
        this.props.formValues,
        value,
        routing_config_type
      );
      const isAddressRequired = response?.address?.required;
      if (isAddressRequired) {
        this.props.setShowBeneSchemaAddress?.(true);
      }
      dispatch(disableLoader());
      !isEmpty(response?.payout_details) &&
        Object.keys(response.payout_details).forEach((field) => {
          if (!isEmpty(response.payout_details[field].render_web)) {
            response.payout_details[field].render = response.payout_details[field].render_web;
            delete response.payout_details[field].render_web;
          }
        });
      const checkForINR =
        this.props.formValues?.bank_account_country === 'IN' &&
        this.props.formValues?.currency_code === 'INR' &&
        this.props.formValues.account_type === INDIVIDUAL;
      let data = response;
      const editMode = this.props.editMode;
      const { onCountryOfResidenceChangeHandler } = this;
      if (checkForINR) {
        data = {
          ...response,
          personal_details: {
            ...beneficiaryFieldsForINvalidation(this.props.formValues?.is_legal_last_name_provided),
            ...response.personal_details
          }
        };
        data = _.omit(data, 'personal_details.beneficiary_name');
      }

      dispatchConstFields({
        data,
        dispatch,
        change,
        formName,
        editMode,
        onCountryOfResidenceChangeHandler,
        isAddressRequired
      });
      onCountryCurrencyPairChange?.(null, response);
      dispatch(change(formName, 'bene_schema_validation', response.payout_details));
      dispatch(storeSchemBeneValiation(response.payout_details));
      dispatch(change(formName, 'routing_config_type_temp', routing_config_type));
      const conditionalValidation = refactorConditionalField(response.conditional_validation);
      await this.setState({
        beneSchema: data,
        beneSchemaOriginal: data,
        conditionalValidation: conditionalValidation
      });
    }
  };

  onCountryOfResidenceChangeHandler = async (data) => {
    const { currentBeneDetails, formValues, isVopTransactionFlow, isNewBeneAddFlow } = this.props;
    const response =
      !(isVopTransactionFlow || isNewBeneAddFlow) &&
      (await this.props.getPayeeJSONSchemaByCountryCode(
        formValues,
        this.state.selectedPayoutMethod,
        data?.value || currentBeneDetails.beneficiary_country_code,
        formValues.routing_config_type_temp || formValues.routing_config_type
      ));
    if (response?.address_details && Object.keys(response?.address_details).length !== 0) {
      let showFields,
        isAddressPrefilled = false;
      const addressSearchOption = response?.search_section?.render?.visibility || false;
      await this.setState({
        addressSchema: response,
        showAddressSearch: addressSearchOption,
        searchBarProps: response?.search_section || null
      });

      if (response?.address_details) {
        Object.keys(response?.address_details).forEach((item) => {
          if (!data?.value && this.props?.currentBeneDetails[item]) {
            isAddressPrefilled = true;
          }
          return true;
        });
      }
      if (addressSearchOption && !isAddressPrefilled) {
        showFields = false;
      } else if (!addressSearchOption) {
        showFields = true;
      } else if (addressSearchOption && isAddressPrefilled) {
        showFields = true;
      } else showFields = false;
      await this.setState({ showFields });
      this.reInitializeForm();
    }
  };

  manualHandlerInvoke = async (formValues) => {
    const beneConfig = this.state.beneSchema;
    const conditionalValidation = this.state.conditionalValidation;
    for (const item of this.EDIT_CASE_MANUAL_HANDLING_FIELDS) {
      const field = get(beneConfig, `${item.group}.${item.field}`, {});
      if (!isEmpty(field)) {
        const func = item['handler'];
        await func();
      }
    }
    if (!isEmpty(conditionalValidation)) {
      for (const key of conditionalValidation.conditionalValidationKeys) {
        const field = get(beneConfig, `payout_details.${key}`, {});
        if (!isEmpty(field)) {
          await this.payoutConditionalValidationHandler(
            key,
            { value: formValues[key] },
            beneConfig,
            conditionalValidation
          );
        }
      }
    }
  };

  payoutConditionalValidationHandler = async (key, selectedData) => {
    const { onCountryCurrencyPairChange } = this.props;
    const currentBeneSchema = cloneDeep(this.state.beneSchemaOriginal);
    const validationObj = this.state.conditionalValidation;
    const conditionalValidationArray = validationObj?.validation?.map(
      (object) => object?.controllingField['proxy_type']?.const
    );
    validationObj.validation?.every((item) => {
      const controllingField = Object.keys(item.controllingField)[0];
      if (controllingField === key || key === 'proxy_value') {
        let dependentField;
        let fieldValidation;
        if (item.controllingField[controllingField]?.const === selectedData?.value) {
          dependentField = Object.keys(item?.dependentField)[0];
          // specific validation(conditional)
          fieldValidation = item['dependentField'][dependentField];
        } else {
          dependentField = 'proxy_value';
          if (conditionalValidationArray.includes(selectedData?.value)) {
            fieldValidation = filter(validationObj?.validation, function (object) {
              return object?.controllingField[controllingField]?.const === selectedData?.value;
            })[0]?.dependentField[dependentField];
          }
          // default validation
          else {
            fieldValidation = get(
              currentBeneSchema,
              `payout_details.${dependentField}.validation`,
              {}
            );
          }
        }
        const validationConfig = get(currentBeneSchema, `payout_details.${dependentField}`, {});
        if (!isEmpty(validationConfig)) {
          currentBeneSchema['payout_details'][dependentField] = merge(validationConfig, {
            render: {
              show_field: true
            },
            validation: {
              ...fieldValidation
            }
          });
        }
        return false;
      }
      return true;
    });
    onCountryCurrencyPairChange?.(null, currentBeneSchema);
    await this.setState({
      beneSchema: currentBeneSchema
    });
  };

  selfPopulatingData = async (data) => {
    const { userStatusReducer, remitterAddress, formName } = this.props;
    const { personal_details } = this.state.beneSchemaOriginal;
    const { address } = this.state.beneSchema;
    const addressRequired = address && address.required;
    if (data.text === 'Self') {
      for (const val of Object.keys(SELF_POPULATING_FIELDS)) {
        if (Object.keys(personal_details).includes(val)) {
          const value = userStatusReducer[SELF_POPULATING_FIELDS[val]];
          if (val === 'beneficiary_country_code' && this.state.beneCountryFieldDisabled) continue;
          this.props.dispatch(change(formName, val, value));
          if (val === 'beneficiary_country_code') {
            await this.onCountryOfResidenceChangeHandler({ value });
          }
        }
      }
      if (addressRequired) {
        const addressData = Object.keys(get(this.props.addressConfig?.addressConfig, 'data', {}));
        const addressFields =
          addressData.length > 0
            ? addressData
            : Object.keys(get(this.state, 'addressSchema.address_details', {}));
        addressFields.forEach((val) => {
          this.props.dispatch(change(formName, val, remitterAddress[val]));
        });
        await this.setState({ showFields: true });
      }
    } else {
      Object.keys(SELF_POPULATING_FIELDS).forEach((val) => {
        if (Object.keys(personal_details).includes(val)) {
          if (val === 'beneficiary_country_code' && this.state.beneCountryFieldDisabled) return;
          this.props.dispatch(change(formName, val, ''));
        }
      });
      if (addressRequired) {
        Object.keys(remitterAddress).forEach((val) => {
          this.props.dispatch(change(formName, val, ''));
        });
      }
    }
  };

  searchListPopulateFieldHandler = (data, onChangeConfig) => {
    const renderStaticValueJSON = {};
    if (!isEmpty(data) && !isEmpty(onChangeConfig)) {
      onChangeConfig.forEach((item) => {
        if (item.populate) {
          const value = data[item.node];
          if (!isEmpty(value)) {
            const isValueArray = isArray(value);
            if (isValueArray) {
              renderStaticValueJSON[item.populate] = value;
              if (value.length === 1) {
                this.props.dispatch(change(this.props.formName, item.populate, value[0].value));
              }
            } else {
              this.props.dispatch(change(this.props.formName, item.populate, value));
            }
          } else {
            this.props.dispatch(change(this.props.formName, item.populate, ''));
          }
        }
      });
    }
    this.setState({
      renderStaticValueJSON: renderStaticValueJSON
    });
  };

  renderBankDetailsDropdownOption = () => {
    const { beneConfig } = this.props || {};
    const dropDown = this.formatBeneConfigToRender(beneConfig);
    const {
      formValues: { routing_config_type, details_selected }
    } = this.props || {};
    return (
      <Grid.Row col>
          <RenderRecevingOptions>
            <div className="innerBox">
              <Field
                bindToThisObject={this.props.formValues['details_selected']}
                component={CommonDropdownOutlined}
                width="100%"
                name="details_selected"
                type="text"
                placeholder={'Recipient Receiving Option'}
                className="theme-dropdown"
                staticValues={this.renderPaypoutMethods(dropDown)}
                value={details_selected}
                onChange={(e, value) => this.payoutMethodSelected(value, dropDown)}
                disabled={!!routing_config_type}
                validate={[required]}
              ></Field>
            </div>
          </RenderRecevingOptions>
      </Grid.Row>
    );
  };

  toggleShowFields = async (value) => {
    await this.setState({ showFields: value });
  };

  clearSuccessIcon = (field) => {
    const { formName, dispatch } = this.props || {};
    dispatch(change(formName, field, false));
  };

  handleEdit = (updateField, clearField) => {
    const { formName, dispatch } = this.props || {};
    dispatch(change(formName, updateField, false));
    dispatch(change(formName, clearField, ''));
  };

  showPickupLocations = async () => {
    const { bank_account_country } = this.props?.formValues || {};
    const locationList = await this.props.getCashPayoutLocationList(bank_account_country);
    if (locationList?.data?.success) {
      return await ModalFactory.builder(
        (onClose) => {
          return <CashPickupLocation onClose={onClose} locationData={locationList.data.data} />;
        },
        'center-modal',
        true,
        { disAbleCloseAnimation: true }
      );
    }
  };

  showValidIds = async () => {
    return await ModalFactory.builder(
      (onClose) => <ValidCashPayoutIdList onClose={onClose} />,
      'center-modal',
      true,
      { disAbleCloseAnimation: true }
    );
  };
  handleLastNameChange = (value) => {
    this.setState({ lastRecordedNameValue: value });
  };

  render() {
    const { payout_details } = this.state.beneSchema;

    const { renderStaticValueJSON } = this.state;

    const { beneConfig, formValues, isVopTransactionFlow, isNewBeneAddFlow, isSingleRowField } =
      this.props || {};

    const selectedPayout = get(formValues, 'details_selected', '');
    const isCashPayoutSelected =
      this.props?.formValues?.details_selected === 'CASH' &&
      this.props?.formValues?.bank_account_country === PH;
    return (
      <>
        {beneConfig && beneConfig.length > 1 && !(isVopTransactionFlow || isNewBeneAddFlow) && (
          <>
            <SectionTitle>Recipient receiving options</SectionTitle>
            <Container columns={3}>{this.renderBankDetailsDropdownOption()}</Container>
          </>
        )}

        {isCashPayoutSelected && (
          <LabelTextWrapper>
            <RenderRecipientNote dangerouslySetInnerHTML={{ __html: cashPickupNote }} />
          </LabelTextWrapper>
        )}
        {payout_details && Object.keys(payout_details).length > 0 && (
          <>
            {!(isVopTransactionFlow || isNewBeneAddFlow) && (
              <SectionTitle>{PAYOUT_TITLE[selectedPayout]}</SectionTitle>
            )}
            <PayoutScreen
              payout_fields={payout_details}
              formName={this.props.formName}
              formValues={formValues}
              clearSuccessIcon={this.clearSuccessIcon}
              conditional_validation={{
                data: this.state.conditionalValidation,
                handler: this.payoutConditionalValidationHandler
              }}
              handleEdit={this.handleEdit}
              searchListPopulateFieldHandler={this.searchListPopulateFieldHandler}
              renderStaticValueJSON={renderStaticValueJSON}
              isSingleRowField={isSingleRowField}
            ></PayoutScreen>
          </>
        )}
      </>
    );
  }
}

BeneDetailsContainer.propTypes = {
  dispatch: PropTypes.func,
  formName: PropTypes.string,
  beneConfig: PropTypes.object,
  formValues: PropTypes.object,
  currentBeneDetails: PropTypes.any,
  initializeFormForBeneService: PropTypes.func,
  isCompleteEditable: PropTypes.bool,
  isPartiallyEditable: PropTypes.bool,
  getPayeeJSONSchemaByRoutingConfigId: PropTypes.func,
  getPayeeJSONSchemaByCountryCode: PropTypes.func,
  userStatusReducer: PropTypes.object,
  remitterAddress: PropTypes.any,
  onCountryCurrencyPairChange: PropTypes.func,
  getCashPayoutLocationList: PropTypes.func,
  setShowBeneSchemaAddress: PropTypes.func,
  addressConfig: PropTypes.object,
  userTier: PropTypes.string,
  editMode: PropTypes.bool,
  userBankInfo: PropTypes.object,
  isVopTransactionFlow: PropTypes.bool,
  isNewBeneAddFlow: PropTypes.bool,
  isSingleRowField: PropTypes.bool
};

function mapStateToProps(reduxState) {
  const {
    rootReducer: {
      userStatusReducer,
      userDataReducer: addressConfig,
      userSessionReducer: {
        user_session: { tier: userTier }
      }
    }
  } = reduxState;

  return {
    userStatusReducer,
    addressConfig,
    userTier
  };
}

export default connect(mapStateToProps, {
  getPayeeJSONSchemaByRoutingConfigId,
  getPayeeJSONSchemaByCountryCode,
  getCashPayoutLocationList
})(BeneDetailsContainer);
